import * as Sentry from '@sentry/react';
import { NavigateOptions } from 'react-router-dom';

type path = {
  pathname: string;
  search: string | undefined;
};

export const navigateWithErrorReporting = (
  navigate: (to: string | path, options?: NavigateOptions) => unknown,
  route: string | path,
  options?: NavigateOptions,
): void => {
  try {
    navigate(route, options);
  } catch (secondError) {
    Sentry.captureException(secondError);
  }
};
